import { BehaviorSubject, tap } from 'rxjs';
import { EventEmitter, inject, Injectable } from '@angular/core';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { SidebarButtonConfig } from '../components/sidebar/sidebar.component';
import { Actions, ofType } from '@ngrx/effects';
import { createFeedFail, editFeedFail } from '../actions/feed.actions';
import { ToastService } from '@services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  private selectedComponentSubject = new BehaviorSubject<string>('');
  private selectedComponentTitleSubject = new BehaviorSubject<string>('');
  private selectedComponentIconSubject = new BehaviorSubject<IconProp>(null);
  private hideButtonsSubject = new BehaviorSubject<boolean>(false);
  private widerPanelSubject = new BehaviorSubject<boolean>(false);

  public componentSelected = new EventEmitter<SidebarButtonConfig>();

  isOpen$ = this.isOpenSubject.asObservable();
  selectedComponent$ = this.selectedComponentSubject.asObservable();
  selectedComponentTitle$ = this.selectedComponentTitleSubject.asObservable();
  selectedComponentIcon$ = this.selectedComponentIconSubject.asObservable();
  hideButtons$ = this.hideButtonsSubject.asObservable();
  isPanelWider$ = this.widerPanelSubject.asObservable();

  private action$ = inject(Actions);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);

  constructor() {
    this.action$
      .pipe(
        ofType(editFeedFail, createFeedFail),
        tap((action: any) => {
          console.log(action);

          this.toastService.showError(
            action?.message
              ? action.message
              : this.translateService.instant(
                  'search-builder.error.form-submit-failed',
                ),
          );
        }),
      )
      .subscribe();
  }

  selectComponent(button: SidebarButtonConfig, forceOpen: boolean = false) {
    const isSameComponentSelected =
      this.selectedComponentSubject.value === button.componentName;
    const isSidebarOpen = this.isOpenSubject.value;

    if (isSameComponentSelected && isSidebarOpen) {
      forceOpen ? this.openSidebar() : this.toggleSidebar();
    } else {
      if (!isSidebarOpen) {
        forceOpen ? this.openSidebar() : this.toggleSidebar();
      }
      this.selectedComponentSubject.next(button.componentName);
      this.selectedComponentTitleSubject.next(button.header);
      this.selectedComponentIconSubject.next(button?.icon);
      this.componentSelected.emit(button);
    }

    if (!this.isOpenSubject.value) {
      this.selectedComponentSubject.next('');
    }
  }

  openSidebar() {
    this.isOpenSubject.next(true);
  }

  closeSidebar() {
    this.isOpenSubject.next(false);
    this.selectedComponentSubject.next('');
    this.selectedComponentTitleSubject.next('');
    this.selectedComponentIconSubject.next(null);
  }

  toggleSidebar() {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  hideButtons(hide: boolean = true) {
    this.hideButtonsSubject.next(hide);
  }

  showButtons() {
    this.hideButtonsSubject.next(false);
  }

  setSidebarWidth(wide: boolean) {
    this.widerPanelSubject.next(wide);
  }
}
